var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6665 3.5C28.4013 3.5 28.1469 3.60536 27.9594 3.79289C27.7719 3.98043 27.6665 4.23478 27.6665 4.5V5.962L5.2165 11.142C4.77584 11.2438 4.38267 11.4919 4.10117 11.8458C3.81966 12.1998 3.66644 12.6387 3.6665 13.091V19.909C3.66644 20.3613 3.81966 20.8002 4.10117 21.1542C4.38267 21.5081 4.77584 21.7562 5.2165 21.858L7.6665 22.423V26.5C7.6665 27.2956 7.98257 28.0587 8.54518 28.6213C9.10779 29.1839 9.87085 29.5 10.6665 29.5H18.6665C19.4622 29.5 20.2252 29.1839 20.7878 28.6213C21.3504 28.0587 21.6665 27.2956 21.6665 26.5V25.654L27.6665 27.038V28.5C27.6665 28.7652 27.7719 29.0196 27.9594 29.2071C28.1469 29.3946 28.4013 29.5 28.6665 29.5C28.9317 29.5 29.1861 29.3946 29.3736 29.2071C29.5611 29.0196 29.6665 28.7652 29.6665 28.5V4.5C29.6665 4.23478 29.5611 3.98043 29.3736 3.79289C29.1861 3.60536 28.9317 3.5 28.6665 3.5ZM19.6665 26.5C19.6665 26.7652 19.5611 27.0196 19.3736 27.2071C19.1861 27.3946 18.9317 27.5 18.6665 27.5H10.6665C10.4013 27.5 10.1469 27.3946 9.9594 27.2071C9.77186 27.0196 9.6665 26.7652 9.6665 26.5V22.885L19.6665 25.192V26.5ZM5.6665 19.909V13.091L27.6665 8.014V24.986L5.6665 19.909Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.2627d1296cdb3059d6c9722248a5d031.svg";
export { ForwardRef as ReactComponent };